import { AvailableLanguages, TRANSLATIONS } from "./i18n/i18n";
import { VALIDATION_RULES } from "./models/validation";

// Utility function to validate form fields
export function validateField(
  field: string,
  value: string,
  currentLanguage: AvailableLanguages
): string | true {
  let rules = VALIDATION_RULES[field];
  if (!rules) rules = VALIDATION_RULES["default"];
  if (!rules) return true;

  value = value.trim();

  if (rules.minLength && value.length < rules.minLength) {
    return (
      (TRANSLATIONS[currentLanguage].validation as Record<string, string>)[
        field
      ] || TRANSLATIONS[currentLanguage].validation["default"]
    );
  }

  if (rules.pattern && !rules.pattern.test(value)) {
    return (
      (TRANSLATIONS[currentLanguage].validation as Record<string, string>)[
        field
      ] || TRANSLATIONS[currentLanguage].validation["default"]
    );
  }

  return true;
}

// Validate input fields dynamically
export function validateInput(
  input: HTMLInputElement,
  currentLanguage: AvailableLanguages
): boolean {
  if (!input.required) return true;

  const validationResult = validateField(
    input.name,
    input.value,
    currentLanguage
  );
  const errorMessage = input.parentElement?.querySelector(".error-message");

  if (validationResult !== true) {
    input.classList.add("border-red-500");
    if (!errorMessage) {
      const error = document.createElement("p");
      error.className = "error-message text-red-500 text-sm mt-1";
      error.textContent = validationResult as string;
      input.parentElement?.appendChild(error);
    } else {
      errorMessage.textContent = validationResult as string;
    }
    return false;
  } else {
    input.classList.remove("border-red-500");
    errorMessage?.remove();
    return true;
  }
}
